// Lectura de las líneas de una oferta (order_lines con atributos JSON), compartida por el
// resumen del configurador y la vista / revisión del pedido.

export const parseAttr = value => (typeof value === 'string' ? JSON.parse(value) : value || {})

export const translate = (value, lang) => (value && typeof value === 'object' ? value[lang] || value.es : value)

export const money = value => `${Number(value || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`

export const offerLines = order => (order && order.lines ? order.lines : []).map(line => ({ line, attr: parseAttr(line.atributos) }))

// Precio de la cortina con el descuento del cliente (como el PDF y recalcularPrecioPedido)
export const curtainAmount = (order, line) => {
  const discount = Number(order.discount) || 0
  return line.amount - (line.amount * discount) / 100
}

/**
 * Filas de cortina con su cuadro y sus extras.
 * state: estado del configurador ({ items, noBox }) si existe; las ofertas antiguas no lo tienen.
 */
export const offerRows = (order, state) => {
  const lines = offerLines(order)
  const items = (state && state.items) || []
  const noBox = (state && state.noBox) || []
  const boxes = lines.filter(l => l.attr.tipo === 'cuadro control')
  return lines.filter(l => l.attr.tipo === 'cortinas').map(row => {
    const refersTo = l => (l.attr.cortinas || []).some(c => c.id === row.line.id)
    const item = items.find(i => i.key === row.line.type)
    const isNoBox = !!item && noBox.includes(item.key)
    return {
      ...row,
      ref: item ? item.ref : row.line.product_object.ref,
      needsBox: item ? item.control_box && !item.sin_tarifa && !isNoBox : false,
      noBox: isNoBox,
      box: boxes.find(refersTo),
      extras: lines.filter(l => l.attr.tipo === 'extras' && refersTo(l)),
    }
  })
}

export const offerBoxes = order => offerLines(order).filter(l => l.attr.tipo === 'cuadro control')

export const hasPricePending = order => offerLines(order).some(l => l.attr.price_pending)
